import { useQuery } from '@tanstack/react-query';
import type { AuditRecord } from '@peles/shared';
import * as auditApi from '../api/audit';

export function useEntityAudit(entityType: string, entityId: string, enabled: boolean = true) {
  return useQuery<AuditRecord[]>({
    queryKey: ['audit', entityType, entityId],
    queryFn: () => auditApi.getEntityAudit(entityType, entityId),
    enabled: enabled && !!entityType && !!entityId,
  });
}
